const API_URL = process.env.REACT_APP_API_URL;

const getAuthHeaders = () => ({
  'Content-Type': 'application/json',
  'Authorization': `Bearer ${localStorage.getItem('token')}`
});

const cartService = {
  async getCart() {
    const response = await fetch(`${API_URL}/user/cart`, {
      headers: getAuthHeaders()
    });
    if (!response.ok) throw new Error('Failed to load cart');
    return response.json();
  },

  async addMenuToCart(menuItemId, selectedIngredients = [], preferredServings = null, includeSpices = false, includeOils = false) {
    const response = await fetch(`${API_URL}/user/cart/menus`, {
      method: 'POST',
      headers: getAuthHeaders(),
      body: JSON.stringify({ menuItemId, selectedIngredients, preferredServings, includeSpices, includeOils })
    });
    if (!response.ok) throw new Error('Failed to add to cart');
    return response.json();
  },

  async removeFromCart(menuItemId) {
    const response = await fetch(`${API_URL}/user/cart/menus/${menuItemId}`, {
      method: 'DELETE',
      headers: getAuthHeaders()
    });
    if (!response.ok) throw new Error('Failed to remove from cart');
    return response.json();
  },

  async updateCount(menuItemId, count) {
    const response = await fetch(`${API_URL}/user/cart/menus/${menuItemId}`, {
      method: 'PATCH',
      headers: getAuthHeaders(),
      body: JSON.stringify({ count })
    });
    if (!response.ok) throw new Error('Failed to update count');
    return response.json();
  },

  async addCustomItem(name, quantity = '1', unit = '') {
    const response = await fetch(`${API_URL}/user/cart/custom`, {
      method: 'POST',
      headers: getAuthHeaders(),
      body: JSON.stringify({ name, quantity, unit })
    });
    if (!response.ok) throw new Error('Failed to add custom item');
    return response.json();
  },

  async updateCustomItem(itemId, updates) {
    const response = await fetch(`${API_URL}/user/cart/custom/${itemId}`, {
      method: 'PATCH',
      headers: getAuthHeaders(),
      body: JSON.stringify(updates)
    });
    if (!response.ok) throw new Error('Failed to update custom item');
    return response.json();
  },

  async removeCustomItem(itemId) {
    const response = await fetch(`${API_URL}/user/cart/custom/${itemId}`, {
      method: 'DELETE',
      headers: getAuthHeaders()
    });
    if (!response.ok) throw new Error('Failed to remove custom item');
    return response.json();
  },

  async sendToInstacart(customItems = []) {
    const response = await fetch(`${API_URL}/user/cart/instacart`, {
      method: 'POST',
      headers: getAuthHeaders(),
      body: JSON.stringify({ customItems })
    });
    if (!response.ok) throw new Error('Failed to create Instacart list');
    return response.json();
  },

  async getSavedLists() {
    const response = await fetch(`${API_URL}/user/cart/saved`, {
      headers: getAuthHeaders()
    });
    if (!response.ok) throw new Error('Failed to load saved lists');
    return response.json();
  },

  async saveList(name, items, menuItemIds = []) {
    const response = await fetch(`${API_URL}/user/cart/saved`, {
      method: 'POST',
      headers: getAuthHeaders(),
      body: JSON.stringify({ name, items, menuItemIds })
    });
    if (!response.ok) {
      const data = await response.json().catch(() => ({}));
      throw new Error(data.error || 'Failed to save list');
    }
    return response.json();
  },

  async updateList(id, name, items, menuItemIds = []) {
    const response = await fetch(`${API_URL}/user/cart/saved/${id}`, {
      method: 'PUT',
      headers: getAuthHeaders(),
      body: JSON.stringify({ name, items, menuItemIds })
    });
    if (!response.ok) {
      const data = await response.json().catch(() => ({}));
      throw new Error(data.error || 'Failed to update list');
    }
    return response.json();
  },

  async loadList(id) {
    const response = await fetch(`${API_URL}/user/cart/saved/${id}`, {
      headers: getAuthHeaders()
    });
    if (!response.ok) throw new Error('Failed to load list');
    return response.json();
  },

  async deleteList(id) {
    const response = await fetch(`${API_URL}/user/cart/saved/${id}`, {
      method: 'DELETE',
      headers: getAuthHeaders()
    });
    if (!response.ok) throw new Error('Failed to delete list');
    return response.json();
  }
};

export default cartService;
